import { red, green, pink } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: green[800],
    },
    secondary: {
      main: pink.A700,
    },
    error: {
      main: red.A400,
    },
    gray: {
      main: '#777',
    },
    lightGray: {
      main: '#ddd',
    },
    background: {
      default: '#fff',
    },
  },
});

export default theme;
